import React from "react";
import PageBuilder from "../../components/PageBuilder/PageBuilder";
import { useSanityContent } from "../../hooks/useSanityContent";
import { PAGE_QUERY } from "../../sanity/queries";

const fallbackSections = [
  {
    _type: "legalSections",
    mainTitle: "STANDARD TERMS AND CONDITIONS",
    effectiveDate: "Effective Date: 1st July 2025",
    sections: [
      { title: "Introduction", paragraphs: [
        "Welcome to August Twenty Limited Liberia. These Terms and Conditions (\"Terms\") govern your use of our website located at www.augusttwenty.co.uk and any related services provided by August Twenty Limited Liberia at Horton House, Horton Avenue, Off Capitol Bypass, Monrovia Liberia.",
        "By accessing or using our services, you agree to be bound by these Terms. If you do not agree, please do not use our services.",
      ]},
      { title: "Our Services", bullets: [
        "August Twenty provides You with meeting rooms, day offices, internet, projector as a short-term rental (per half-day, day or week or maximum one month) as booked by You online or in person.",
        "WiFi is provided as part of our services. To ensure a consistent and reliable experience for all clients, usage is subject to a Fair Use policy. Horton House reserves the right to manage bandwidth and restrict excessive or non-standard usage where necessary.",
      ]},
      { title: "Use of Services", bullets: [
        "You must be at least 18 years old to use our services.",
        "You agree to use our services only for lawful purposes and in accordance with these Terms.",
        "You must not misuse or interfere with our services or try to access them using a method other than the interface and instructions we provide.",
      ]},
      { title: "Intellectual Property (applicable to our Website)", bullets: [
        "All content, trademarks, logos, and intellectual property on our site are owned by August Twenty Limited or its licensors.",
        "You may not reproduce, distribute, or create derivative works from our content without prior written permission.",
      ]},
      { title: "User Accounts (applicable to Internet services)", bullets: [
        "You may be required to create an account to access certain features.",
        "You are responsible for maintaining the confidentiality of your account credentials.",
        "You agree to notify us immediately of any unauthorized use of your account.",
      ]},
      { title: "Cancellation Policies", bullets: [
        "The below rules apply to Meeting Room, and all types of Day Office Bookings. The cancellation policy is based on notice period given.",
        "You are entitled to a full refund, when the cancellation is made 10 days or more in advance of the event date.",
        "You are entitled to a 50% refund, when the cancellation is made 5 – 9 days in advance of the event date.",
        "No refund will be given for less than 5 days' notice.",
        "If a booking is changed to a different day within the cancellation period, a change fee of USD 20 may apply.",
        "If a cancellation is made within two hours of the booking creation, then you are entitled to a full refund. However, this policy does not apply for same day bookings.",
        "Any services that We are charged for by third parties on Your behalf will be charged through to You regardless of the above cancellation policy.",
        "If a booking is for multiple or consecutive days, the cancellation policy applies to each individual day within the booking.",
      ]},
      { title: "Payments and Billing", bullets: [
        "All fees are clearly stated on our rate card (exclusive if applicable Local Government Taxes).",
        "We reserve the right to change our pricing at any time, with 7 days' notice provided.",
        "Unless otherwise stated on our invoice, all fees must be paid in full before use of our services.",
      ]},
      { title: "Termination", bullets: [
        "We may suspend or terminate your access to our services at any time, without prior notice, for conduct that violates these Terms or is harmful to other users or us.",
        "Your booking is automatically cancelled if payment has not been received in full prior to use.",
      ]},
      { title: "Limitation of Liability", bullets: [
        "To the maximum extent permitted by law, August Twenty Limited Liberia shall not be liable for any indirect, incidental, or consequential damages arising from your use of our services.",
      ]},
      { title: "Disclaimer", bullets: [
        "Our services are provided \"as is\" and \"as available\" without warranties of any kind.",
        "We do not guarantee that our services will be uninterrupted or error-free.",
      ]},
      { title: "Governing Law", bullets: [
        "These Terms shall be governed by and construed in accordance with the laws of the Republic of Liberia and all parties irrevocably agree that the courts of the Republic of Liberia shall have exclusive jurisdiction to settle any dispute or claim arising out of or in connection with these terms.",
      ]},
      { title: "Changes to Terms", bullets: [
        "We reserve the right to amend these Terms at any time.",
        "Continued use of our services after changes constitutes acceptance of the new Terms.",
      ]},
      { title: "Contact Us", paragraphs: [
        "If you have any questions about these Terms, please contact us at enquiries@augusttwenty.co.uk.",
      ]},
    ],
  },
];

export default function TermsAndConditions() {
  const { data } = useSanityContent(PAGE_QUERY("terms-and-conditions"), { sections: fallbackSections });
  return <PageBuilder sections={data.sections} />;
}
